module.exports = __webpack_public_path__ + "media/images/loghi/mylba-f8a601cfca311b17f9cdfa69c58ad15e.png";